<kf-alert>
  <kf-modal modal="{ state.modal }">
    <div class="alert-container">
      <div class="alert-message">{ state.message }</div>
      <div class="alert-button-group text-right">
        <button class="btn btn-blue btn-ok" onclick="{ onOK }">OK</button>
      </div>
    </div>
  </kf-modal>
  <script>
    import { KfModal } from '../kf-modal';
    import { model, ALERT_OK, ALERT_OPEN, ALERT_CLOSE } from './observable';
    export default {
      components: {
        KfModal,
      },
      state: {
        message: '',
        modal: {
          show: false,
          size: 450,
        },
      },
      onMounted() {
        document.addEventListener('keyup', this.onKeyUp, { passive: true });
        model.on(ALERT_OPEN, this.alertOpen);
        model.on(ALERT_CLOSE, this.alertClose);
      },
      onUnmounted() {
        document.removeEventListener('keyup', this.onKeyUp);
        model.off(ALERT_OPEN, this.alertOpen);
        model.off(ALERT_CLOSE, this.alertClose);
      },
      alertOpen(message) {
        this.update({
          message,
          modal: {
            ...this.state.modal,
            show: true,
          },
        });
        const btnOk = this.$('.btn-ok');
        if (btnOk != null) {
          btnOk.focus();
        }
      },
      alertClose() {
        model.trigger(ALERT_OK);
        this.closeModal();
      },
      closeModal() {
        this.update({
          message: '',
          modal: {
            ...this.state.modal,
            show: false,
          },
        });
      },
      onKeyUp(e) {
        const key = e.key || e.code;
        if (key === 'Escape') {
          model.trigger(ALERT_OK);
          this.closeModal();
        }
      },
      onOK() {
        model.trigger(ALERT_OK);
        this.closeModal();
      },
    };
  </script>
  <style>
    :host kf-modal .modal-container {
      z-index: 20000;
    }

    .alert-container {
      padding: 24px 16px 16px 16px;
    }

    .alert-message {
      white-space: pre-line;
      min-height: 40px;
    }

    .alert-button-group {
      margin-top: 12px;
    }

    .btn-ok {
      width: 90px;
      padding: 0;
      margin: 0;
    }

    .btn-ok {
      margin-right: 8px;
    }
  </style>
</kf-alert>